'use strict';

(function () {
  'use strict';

  angular.module('msWidgets').directive('msWidgetToolsTracker', [function () {
    return {
      template: '<ms-mood-buttons \n                   tracker="::vm.tracker"\n                   input-value="::vm.previousResponse"\n                   output-value="vm.saveEntry(value)"\n                   read-only="isResponse"\n                   class="in-focus">\n                 </ms-mood-buttons>',
      controller: 'msWidgetToolsTrackerController',
      controllerAs: 'vm',
      bindToController: true
    };
  }]).controller('msWidgetToolsTrackerController', ['$scope', 'moodTrackerSvc', function ($scope, moodTrackerSvc) {
    var vm = this;
    vm.$onInit = _activate;
    vm.saveEntry = _saveEntry;

    function _activate() {
      // Set vm values from widget properties.
      var trackerId = $scope.widget.properties.trackerId;
      moodTrackerSvc.getTrackerById(trackerId).then(function (data) {
        vm.tracker = data;
      });

      vm.previousResponse = $scope.widget.response;

      // If this widget already has a repsonse (history view),
      // get the mood entry with the ID that matches the widget response.
      if (vm.previousResponse) {
        moodTrackerSvc.getMoodEntryById(vm.previousResponse).then(function (result) {
          vm.savedMoodEntry = result;
          vm.previousResponse = (result.value - 50) / 50;
        });
      }
    }

    function _saveEntry(value) {
      // If we've already saved a mood value (the user has changed their answer), just add the new value and save again.
      var moodEntry = angular.extend(vm.savedMoodEntry || { moodSliderId: vm.tracker.id }, { value: value });

      // Set vm.savedMoodEntry from the response (this adds the entryId prop). 
      // If the user changes their response, the initial entry will be updated, rather than having a new one created.
      moodTrackerSvc.saveMood(moodEntry).then(function (result) {
        return vm.savedMoodEntry = result.response.moodSliderEntries[0];
      });
    }
  }]);
})();